/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 15:21:20
 * @LastEditTime: 2021-01-22 13:22:11
 * @LastEditors: daikeyi
 */
import Vue from 'vue';
import Vuex from 'vuex';
import Vant from 'vant';
import Router from 'vue-router';
import { ESVPlugin, ESVStorage, ESVCommon } from 'esvcp-mobile';
import { ESVUIPlugin, App } from 'esvcp-mobile-ui';
import { isAndroidOrIOS } from '@/utils/base/utils';
import 'esvcp-mobile-ui/esvcp-mobile-ui/static/css/esvcp-mobile-ui.css';
import './assets/styles/reset.scss';
import './assets/styles/common/base.scss';
import './assets/styles/iconfont.scss';
import '@/assets/img/icon';
import routes from './routers';
import config from './constant/config.js';
import store from '../src/store/index.js';
import { doRequest } from './http/http.js';
import { wxPromiseFunc, onMenuFriend } from '@/base/wxPromiseFunc';
import navigation from '@/components/base/navigation';
import noData from '@/components/base/noData';
// import vueSignature from 'vue-signature';
// import VueAMap from 'vue-amap';
// import VueClipboard from 'vue-clipboard2';

import VConsole from 'vconsole';

// 初始化Vue工具参数
Vue.config.productionTip = process.env.TYPE !== 'dev';
Vue.config.silent = process.env.TYPE !== 'dev';
Vue.config.performance = process.env.TYPE === 'dev';

Vue.use(Vant);
Vue.use(Vuex);
Vue.use(Router);

Vue.component('navigation', navigation);
Vue.component('noData', noData);

const configs = {};

configs[config.PrefixName] = config;
routes.forEach(r => {
    if (!r.meta) {
        r.meta = {};
    }
    r.meta.PrefixName = config.PrefixName;
});

const RouterConfig = {
    routes: routes
};

const router = new Router(RouterConfig);
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    // if (from.name !== 'OPActivityPage') {
    //     onMenuFriend();
    // }
    next();
});
ESVPlugin.setCommonWxPromiseFunc(wxPromiseFunc);

Vue.use(ESVPlugin, {
    store: store,
    router: router,
    containerIdName: 'app',
    platform: process.env.PLATFORM,
    env: process.env.NODE_ENV,
    type: process.env.TYPE,
    configs: configs,
    loginConfig: {
        forceLogin: false,
        loginPageName: 'OPLogin',
        uniqueKey: ''
    }
});
// ios分享需要做一次强制刷新
if (isAndroidOrIOS() === 'ios') {
    ESVStorage.getSessionValue('onceActive', (data) => {
        if (!data) {
            ESVStorage.putSessionValue('onceActive', '1');
        }
    });
}
const host = window.location.host;
if (host.indexOf('localhost') > -1 || host.indexOf('192.168.') > -1 || host.indexOf('10.10.') > -1 || host.indexOf('test-new.eslink.net.cn') > -1) {
    // eslint-disable-next-line no-new
    new VConsole();
}
Vue.use(ESVUIPlugin);
Vue.prototype.$doRequest = doRequest;
Vue.prototype.$common = ESVCommon;
wx.error(function (res) {
    console.log('error: ' + res.errMsg);
});
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store: store,
    components: {
        App
    },
    template: '<App/>'
});
